import { Injectable } from '@angular/core';
import { PaymentMethodName } from '../../enums/payment/payment-method-name';
import { OrganisationShopConfigData } from '../../interfaces/organisation/organisation-shop-config-data';
import { PaymentTypeContractData } from '../../interfaces/payment/payment-type-contract-data';

@Injectable({
  providedIn: 'root'
})
export class ContractDataToContractDtoMapperService {

  public map(shopData: OrganisationShopConfigData, contractData: PaymentTypeContractData, paymentMethod: PaymentMethodName, paymentTypeId: string): any {
    switch (paymentMethod) {
      case PaymentMethodName.CREDITCARD:
      case PaymentMethodName.CREDITCARD_MOTO:
        return {
          paymentTypeId: paymentTypeId,
          tenantId: shopData.tenantId,
          shopType: shopData.shopType,
          paymentMethod: paymentMethod,
          creditCardBrand: contractData.creditCardBrand,
          creditCardAcceptancePoint: contractData.creditCardAcceptancePoint,
          vuNumber: contractData.vuNumber,
          contractOptions: contractData.contractOptions,
          currency: contractData.currency,
          mcc: contractData.mcc,
          terminalId: contractData.terminalId
        };
      case PaymentMethodName.PAYPAL:
        return {
          paymentTypeId: paymentTypeId,
          tenantId: shopData.tenantId,
          shopType: shopData.shopType,
          paymentMethod: paymentMethod,
          payPalEmailAddress: contractData.payPalEmailAddress,
          payPalMerchantId: contractData.payPalMerchantId,
          payPalPartnerId: contractData.payPalPartnerId
        };
      case PaymentMethodName.SEPA:
      case PaymentMethodName.SEPA_BLACKLIST:
        return {
          paymentTypeId: paymentTypeId,
          tenantId: shopData.tenantId,
          shopType: shopData.shopType,
          paymentMethod: paymentMethod,
          creditorId: contractData.creditorId,
          accountHolder: contractData.accountHolder,
          IBAN: contractData.IBAN,
          BIC: contractData.BIC,
          billingType: contractData.billingType,
          nameOnBankStatement: contractData.nameOnBankStatement,
          nameOnSEPAMandate: contractData.nameOnSEPAMandate
        };
      case PaymentMethodName.DIRECTTRANSFER:
        return {
          paymentTypeId: paymentTypeId,
          tenantId: shopData.tenantId,
          shopType: shopData.shopType,
          paymentMethod: paymentMethod
        };
      case PaymentMethodName.APPLEPAY:
      case PaymentMethodName.GOOGLEPAY:
        return {
          paymentTypeId: paymentTypeId,
          tenantId: shopData.tenantId,
          shopType: shopData.shopType,
          paymentMethod: paymentMethod,
          activeCreditCardId: contractData.activeCreditCardId,
        };
    }
  }
}
